import { isFunction, __DEV__ } from './assertion.js';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => { };
function runIfFn(valueOrFn, ...args) {
    return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
function once(fn) {
    // eslint-disable-next-line @typescript-eslint/init-declarations
    let result;
    return function func(...args) {
        if (fn) {
            result = fn.apply(this, args);
            // eslint-disable-next-line no-param-reassign
            fn = null;
        }
        return result;
    };
}
const warn = once((options) => () => {
    const { condition, message } = options;
    if (condition && __DEV__) {
        console.warn(message);
    }
});
const error = once((options) => () => {
    const { condition, message } = options;
    if (condition && __DEV__) {
        console.error(message);
    }
});
function safeInvoke(fn, ...args) {
    return fn?.(...args);
}
function debounce(func, wait = 300, immediate = false) {
    // eslint-disable-next-line @typescript-eslint/init-declarations
    let timeout;
    return function executedFunction(...args) {
        // eslint-disable-next-line func-style
        const later = function () {
            timeout = null;
            if (!immediate)
                func.apply(this, args);
        };
        // @ts-ignore
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (immediate)
            func.apply(this, args);
    };
}

export { debounce, error, noop, once, runIfFn, safeInvoke, warn };
//# sourceMappingURL=function.js.map
